// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "c27e645",
    "hash": "c27e645",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "c27e645",
    "semverString": null,
    "version": "v1.9.0",
    "time": 1662425016225
};
/* tslint:enable */
